export class IntensityDto {
  public id: number;
  public key: string;
  public value: number;

  public static fromJson(json: any): IntensityDto {
    return {
      id: json.id,
      key: json.key,
      value: json.value,
    } as IntensityDto;
  }
}
